// src/lib/axios.ts
import axios from "axios";
var api = axios.create({
  baseURL: "https://entregasexpressas.com.br/api/v1",
  headers: {
    "Content-Type": "application/json"
  }
});

// src/auth.ts
var authConfig = (api_key) => {
  api.defaults.headers.common["Authorization"] = `Bearer ${api_key}`;
};

// src/orders.ts
var createOrder = async (order) => {
  try {
    const response = await api.post("/orders", order);
    return response;
  } catch (error) {
    console.error("Error creating order:", error);
    throw error;
  }
};
var calculateRoute = async (order) => {
  try {
    const response = await api.post("/orders/calcular", order);
    return response;
  } catch (error) {
    console.error("Error creating order:", error);
    throw error;
  }
};
var cancelOrder = async (orderId) => {
  try {
    const response = await api.delete(`/orders/${orderId}`);
    return response;
  } catch (error) {
    console.error("Error creating order:", error);
    throw error;
  }
};

// src/users.ts
var getUser = async ({ email, external_id }) => {
  try {
    const response = await api.get(`/usuarios?email`, {
      params: {
        email,
        external_id
      }
    });
    return response;
  } catch (error) {
    console.error("Error creating order:", error);
    throw error;
  }
};
export {
  authConfig,
  calculateRoute,
  cancelOrder,
  createOrder,
  getUser
};
